import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'src/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        // Solid variants
        default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',

        black: 'border-transparent bg-black text-white hover:bg-black/80',

        slate: 'border-transparent bg-slate text-white shadow hover:bg-slate/80',

        // Status colors (solid)
        success: 'border-transparent bg-success text-success-foreground shadow hover:bg-success/80',
        warning: 'border-transparent bg-warning text-warning-foreground shadow hover:bg-warning/80',

        // Info variant (blue)
        info: 'border-transparent bg-info text-info-foreground shadow hover:bg-info/80',

        // Soft variants
        secondarySoft: 'border-transparent bg-secondary/50 text-secondary-foreground',
        slateSoft: 'border-transparent bg-muted/15 text-muted-foreground',
        destructiveSoft: 'border-destructive/20 bg-destructive/10 text-destructive',
        successSoft: 'border-success/20 bg-success/10 text-success-text',
        warningSoft: 'border-warning/20 bg-warning/10 text-warning-text',
        infoSoft: 'border-info/20 bg-info/10 text-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
